export const ru: Record<string, string> = {
  // ---------- Tabs ----------
  "tabs.dashboard": "Дашборд",
  "tabs.charts": "Графики",
  "tabs.records": "Записи",
  "tabs.shifts": "Смены",
  "tabs.people": "Люди",
  "tabs.settings": "Настройки",
  "tabs.report": "Отчёт",
  "tabs.emergency": "Экстренная",
  "tabs.my_records": "Мои записи",
  "tabs.turbines": "Турбины",
  "tabs.automatika": "Автоматика",

  // ---------- Автоматика (телеметрия SCADA) ----------
  "auto.sub_overview": "Обзор",
  "auto.sub_charts": "Графики",
  "auto.sub_anomalies": "Отклонения",
  "auto.sub_data": "Данные",
  "auto.all": "Всё",
  "auto.last_3d": "Последние 3 дня",
  "auto.last_1d": "Последний день",
  "auto.data_range": "Данные",
  "auto.timeframe": "Таймфрейм",
  "auto.tf_all": "Все данные",
  "auto.tf_7d": "Последние 7 дней",
  "auto.tf_3d": "Последние 3 дня",
  "auto.tf_1d": "Последние 24 часа",
  "auto.tf_12h": "Последние 12 часов",
  "auto.tf_6h": "Последние 6 часов",
  "auto.tf_1h": "Последний час",
  "auto.tf_custom": "Свой период…",
  "auto.hide_zeros": "Скрыть нули",
  "auto.truncated": "показаны топ-500",
  "auto.tap_for_details": "Нажмите — все показатели",
  "auto.snapshot_title": "📸 Состояние в этот момент",
  "auto.resolution": "Разрешение",
  "auto.res_auto": "Авто",
  "auto.res_raw": "Посекундно",
  "auto.reset_zoom": "Сбросить зум",
  "auto.deviations_n": "{n} с отклонением",
  "auto.drill_hint": "Нажмите на любую точку, чтобы приблизить; или потяните нижний ползунок и нажмите «Зум в выделение». Красные точки — там было отклонение.",
  "auto.zoom_to_sel": "Зум в выделение",
  "auto.back": "← Назад",
  "auto.filter_metric": "Фильтр по показателю",
  "auto.all_metrics": "Все показатели",
  "auto.minutes": "мин",
  "auto.min_short": "мин",
  "auto.bucket": "интервал",
  "auto.kpi_running": "В работе",
  "auto.kpi_peak_power": "Пик мощности",
  "auto.kpi_avg": "сред",
  "auto.kpi_span": "Период",
  "auto.kpi_energy": "Выработка",
  "auto.kwh": "кВт·ч",
  "auto.mwh": "МВт·ч",
  "auto.col_metric": "Показатель",
  "auto.no_anomalies": "Значимых отклонений за период нет.",
  "auto.anomalies_hint": "{n} событий (≥ {floor}% от нормы, за пределами ±2σ в периоды работы).",
  "auto.off_normal": "от нормы",
  "auto.normal": "норма",
  "auto.when": "когда",
  "auto.upload_title": "Загрузить CSV со станции",
  "auto.upload_hint": "Экспорт SCADA (пробел-разделитель, .csv или .gz). Большие файлы — заливайте .gz. Обрабатывается в фоне; данные отдельны от ручных показаний.",
  "auto.uploading": "Загрузка…",
  "auto.upload_started": "Файл принят — идёт фоновая обработка…",
  "auto.upload_done": "Готово — загружено {rows} строк.",
  "auto.upload_error": "Ошибка обработки — проверьте формат файла.",
  "auto.export_xlsx": "📥 Скачать Excel (за период)",
  "auto.export_hint": "Сырые посекундные строки за выбранный период, исходные колонки, один день = один лист.",
  "auto.imports_title": "Загрузки",
  "auto.col_file": "Файл",
  "auto.col_status": "Статус",
  "auto.col_rows": "Строк",
  "auto.col_period": "Период",

  // ---------- Turbines ----------
  "turbines.title": "🏭 Турбины",
  "turbines.empty_for_station": "На вашей станции пока нет турбин. Обратитесь к админу.",
  "turbines.none_for_station": "Турбин нет.",
  "turbines.active": "активна",
  "turbines.inactive": "выключена",
  "turbines.status_running": "запущена",
  "turbines.status_stopped": "остановлена",
  "turbines.status_off": "отключена",
  "turbines.activate": "Активировать",
  "turbines.deactivate": "Деактивировать",
  "turbines.state_running": "Работает",
  "turbines.state_stopped": "Остановлена",
  "turbines.state_off": "Выведена из эксплуатации",
  "turbines.start_btn": "Старт",
  "turbines.start_sub": "Запустить, зафиксировав текущий KV",
  "turbines.start_title": "Запуск {name}",
  "turbines.confirm_start": "Запустить",
  "turbines.stop_btn": "Стоп",
  "turbines.stop_sub": "Остановить с указанием KW, времени и причины",
  "turbines.stop_title": "Остановка {name}",
  "turbines.confirm_stop": "Остановить",
  "turbines.stop_time": "Время остановки",
  "turbines.stop_reason": "Причина",
  "turbines.stop_reason_placeholder": "Почему турбина остановлена?",
  "turbines.recent_events": "История событий",
  "turbines.evt_start": "Старт",
  "turbines.evt_stop": "Стоп",
  "turbines.tab_list": "Турбины",
  "turbines.tab_history": "История",
  "turbines.no_events": "Событий ещё нет.",
  "turbines.fill_btn": "Заполнить отчёт",
  "turbines.fill_sub": "Внести показания по этой турбине",
  "turbines.fill_sub_offline": "Турбина стоит — запись будет оранжевой",

  // ---------- Common ----------
  "common.loading": "Загрузка…",
  "common.cancel": "Отмена",
  "common.save": "Сохранить",
  "common.delete": "Удалить",
  "common.edit": "Изменить",
  "common.create": "Создать",
  "common.close": "Закрыть",
  "common.retry": "Повторить",
  "common.back": "Назад",
  "common.add": "Добавить",
  "common.submit": "Отправить",
  "common.no_changes": "Без изменений",
  "common.saved": "Сохранено",
  "common.copied": "Скопировано",
  "common.copy_link": "📋 Скопировать ссылку",
  "common.no_data": "За выбранный период данных нет.",
  "common.empty": "Пока пусто.",
  "common.error_generic": "Что-то пошло не так. Попробуйте ещё раз.",
  "common.no_connection": "Нет соединения с сервером",
  "common.timeout": "Сервер не отвечает — попробуйте ещё раз",

  // ---------- Access / desktop hint ----------
  "access.locked_title": "Доступ закрыт",
  "access.locked_hint": "Открыть приложение могут только зарегистрированные пользователи. Попросите администратора прислать ссылку-приглашение.",
  "desktop_hint.title": "Откройте в Telegram",
  "desktop_hint.body": "Это Telegram Mini App. Откройте бота в Telegram и нажмите 📱 рядом с полем ввода.",

  // ---------- Periods ----------
  "period.today": "Сегодня",
  "period.yest": "Вчера",
  "period.7d": "7 дней",
  "period.30d": "30 дней",
  "period.all": "Всё",

  // ---------- Status / types ----------
  "status.completed": "✅",
  "status.miss_short": "miss",
  "type.plan": "План",
  "type.emergency": "🚨 Emergency",
  "type.missed": "🚫 Missed",
  "type.late": "🟨 Late",
  "type.offline": "🟠 Offline",
  "filter.all": "Все",

  // ---------- Charts ----------
  "charts.title": "📈 Графики",
  "charts.select_chart": "Выбрать график",
  "charts.turbine": "Турбина",
  "charts.period": "Период",
  "charts.kw_kv_label": "Колебания KW и KV",
  "charts.kw_kv_title": "Динамика KW и KV",
  "charts.kw_kv_hint": "Две линии: KW (левая ось) и KV (правая ось). Видно скачки напряжения.",
  "charts.kw_kv_offline_title": "Динамика KW и KV (при остановленной турбине)",
  "charts.kw_kv_offline_hint": "Только записи, внесённые когда турбина была остановлена. KW (оранжевый, левая ось) и KV (фиолетовый, правая ось).",

  "charts.compare_label": "Сравнение турбин (KW)",
  "charts.compare_hint": "Линии мощности обеих турбин на одном графике. Помогает увидеть, насколько равномерно распределена нагрузка и какая турбина простаивает.",

  "charts.timeline_label": "Таймлайн работы/простоя",
  "charts.timeline_hint": "Полосы для каждой турбины по времени: зелёные сегменты — работала, красные — стояла. На один экран ложится весь downtime за период.",
  "charts.timeline_running": "Работает",
  "charts.timeline_stopped": "Остановлена",

  "charts.temperatures_label": "Температуры BT",
  "charts.temperatures_hint": "Температурные датчики BT 371, BT 372, BT 331, BT 332 на одном графике. Резкий рост любой кривой — сигнал перегрева и риск аварии.",

  "charts.frequency_label": "Частота (Frequency Hz)",
  "charts.frequency_hint": "Частота генерации (Hz) с нормативными границами 49.5–50.5. Любое отклонение более чем на 0.5 Hz — проблема в энергосети.",
  "charts.freq_low": "49.5 Hz (нижн.)",
  "charts.freq_high": "50.5 Hz (верх.)",

  "charts.stop_reasons_label": "Причины остановок",
  "charts.stop_reasons_hint": "Распределение причин из формы Stop турбины. Помогает понять, какие проблемы случаются чаще всего и куда направить ресурсы.",
  "charts.stop_reasons_empty": "За период не было остановок турбин.",
  "charts.reason_unknown": "Без указания",

  "charts.kw_histogram_label": "Распределение KW (гистограмма)",
  "charts.kw_histogram_hint": "Сколько раз показания мощности попали в каждый диапазон по 200 KW. Видно, в каком режиме турбина работает чаще всего.",

  "charts.cos_kvar_label": "cos φ и Kvar",
  "charts.cos_kvar_hint": "Коэффициент мощности cos φ (левая ось, 0..1) и реактивная мощность Kvar (правая ось). Падение cos φ = проблемы качества генерации.",

  "charts.pressure_label": "Давления (BP 371, Bar, Pipe pressure)",
  "charts.pressure_hint": "Все давления на одном графике. Резкие скачки указывают на аварийные ситуации в гидравлическом или паровом контуре.",

  "charts.scatter_label": "KW vs KV (scatter)",
  "charts.scatter_hint": "Точечная диаграмма: каждая точка — одно измерение. Видна корреляция между мощностью и напряжением, аномальные точки выделяются.",

  "analysis.title": "Анализ",
  "analysis.no_data": "Данных за период недостаточно для анализа.",
  "analysis.records": "Учтено записей: {n}.",

  "analysis.kv_ok": "Напряжение в норме (KV {min}–{max}, диапазон 17–22).",
  "analysis.kv_out": "Напряжение вне нормы (KV {min}–{max}, ожидается 17–22). Проверьте состояние сети.",
  "analysis.kw_stable": "Мощность стабильна, средняя {avg} KW.",
  "analysis.kw_unstable": "Мощность нестабильна: разброс {cv}% от среднего {avg} KW. Проверьте нагрузку.",

  "analysis.turbine_idle": "{name}: за период данных нет — турбина простаивала.",
  "analysis.turbine_avg": "{name}: средняя мощность {avg} KW.",
  "analysis.compare_balanced": "Нагрузка распределена равномерно между турбинами.",
  "analysis.compare_imbalance": "Дисбаланс нагрузки: {hi} ({hiAvg} KW) значительно выше {lo} ({loAvg} KW).",

  "analysis.timeline_overall": "Время работы суммарно по всем турбинам: {uptime}%. Всего остановок: {stops}.",
  "analysis.timeline_turbine": "{name}: работала {uptime}% времени, простой {downtime}.",

  "analysis.temp_ok": "Температуры в норме, max {max}°C (порог 70°C).",
  "analysis.temp_warn": "Повышенная температура, max {max}°C. Норма до 70°C, критично >85°C — следите за датчиками.",
  "analysis.temp_critical": "Перегрев! Max {max}°C на датчиках: {sensors}. Требуется внимание.",
  "analysis.temp_avg": "Средняя температура: {avg}°C.",

  "analysis.freq_ok": "Частота стабильна: {min}–{max} Hz, в пределах нормы 49.5–50.5.",
  "analysis.freq_bad": "Частота отклонялась от нормы: ниже 49.5 — {low} точек, выше 50.5 — {high} точек (из {total}).",
  "analysis.freq_avg": "Средняя частота: {avg} Hz.",

  "analysis.stop_none": "За период не было остановок турбин — отлично.",
  "analysis.stop_total": "Всего остановок: {n}.",
  "analysis.stop_top": "Самая частая причина: «{name}» ({pct}%).",
  "analysis.stop_dominant": "Доминирует одна причина: «{name}» ({pct}% всех остановок). Стоит разобраться с источником.",
  "analysis.stop_variety": "Разнообразие причин: {n} разных категорий.",

  "analysis.hist_top": "Чаще всего мощность в диапазоне {range} KW ({pct}%).",
  "analysis.hist_low": "{pct}% записей с низкой мощностью — частые недозагрузки.",
  "analysis.hist_normal": "{pct}% работы на нормальной нагрузке.",
  "analysis.hist_avg": "Средняя мощность: {avg} KW.",

  "analysis.cos_ok": "cos φ в норме (среднее {avg}). Высокое качество генерации.",
  "analysis.cos_warn": "cos φ снижен (среднее {avg}). Норма ≥0.95, рекомендуется компенсация реактивной мощности.",
  "analysis.cos_bad": "cos φ низкий (среднее {avg}). Серьёзные потери — недозагрузка или большая реактивная нагрузка.",
  "analysis.kvar_avg": "Kvar: среднее {avg}, диапазон {min}–{max}.",

  "analysis.pressure_field": "{name}: ср. {avg}, диапазон {min}–{max}.",

  "analysis.scatter_few": "Слишком мало точек для анализа корреляции.",
  "analysis.scatter_points": "На графике {n} точек.",
  "analysis.scatter_corr_pos": "Сильная прямая связь KW и KV (r={r}). С ростом мощности растёт и напряжение.",
  "analysis.scatter_corr_neg": "Сильная обратная связь KW и KV (r={r}). С ростом мощности напряжение падает.",
  "analysis.scatter_corr_none": "Явной корреляции между KW и KV нет (r={r}).",

  // ---------- Dashboard ----------
  "dashboard.title": "📊 Дашборд",
  "dashboard.kpi.completed": "Заполнено",
  "dashboard.kpi.completed_sub": "{pct}% от плана",
  "dashboard.kpi.total": "Всего слотов",
  "dashboard.kpi.missed": "🚫 Пропуски",
  "dashboard.kpi.late": "🟨 Опоздания",
  "dashboard.kpi.emergency": "🚨 ЧП",
  "dashboard.kpi.avg_response": "Avg отклик",
  "dashboard.kpi.avg_response_sub": "От уведомления до старта",
  "dashboard.kpi.avg_kw": "Среднее KW",
  "dashboard.kpi.avg_kv": "Среднее KV",
  "dashboard.kpi.min_max_sub": "min / max за период",
  "dashboard.kpi.min": "min",
  "dashboard.kpi.max": "max",
  "dashboard.turbines.downtime": "Простой",
  "dashboard.turbines.last_reading": "Посл. запись",
  "dashboard.turbines.no_downtime": "Без простоев",
  "dashboard.turbines.no_data": "нет данных",
  "dashboard.turbines.just_now": "только что",
  "dashboard.turbines.ago": "назад",
  "dashboard.turbines.unit_d": "д",
  "dashboard.turbines.unit_h": "ч",
  "dashboard.turbines.unit_min": "мин",
  "dashboard.sparkline.title": "Тренд KW за 24 часа",
  "dashboard.sparkline.hint": "Все онлайн-показания мощности по обеим турбинам",
  "dashboard.distribution.title": "Распределение слотов",
  "dashboard.distribution.on_time": "✅ Вовремя",
  "dashboard.distribution.late": "🟨 Опоздания",
  "dashboard.distribution.missed": "🚫 Пропуски",
  "dashboard.distribution.pending": "⏳ В работе",
  "dashboard.distribution.emergency": "🚨 ЧП",
  "dashboard.by_day.title": "Заполнение по дням, %",
  "dashboard.by_day.tooltip": "{pct}% ({completed}/{total})",
  "dashboard.by_day.tooltip_label": "Заполнение",
  "dashboard.by_hour.title": "Заполнение по часам суток",
  "dashboard.by_hour.legend": "🟢 высокая дисциплина · 🟡 средне · 🔴 частые пропуски",
  "dashboard.by_hour.legend_count": "Сколько отчётов было внесено в каждый час суток (за выбранный период).",
  "dashboard.by_hour.no_data": "нет данных",
  "dashboard.users.title": "Рейтинг ответственных",
  "dashboard.users.col_name": "Имя",
  "dashboard.users.col_avg": "Avg отклик",
  "dashboard.users.bar_title": "Среднее время отклика, сек",
  "dashboard.empty": "За выбранный период данных нет. Попробуйте другой период или подождите следующего часового тика.",

  // ---------- Records (admin) ----------
  "records.title": "📋 Записи",
  "records.from": "От",
  "records.to": "До",
  "records.download_xlsx": "📥 Скачать Excel",
  "records.xlsx_per_day": "Каждый день периода — отдельный лист (формат ведомости показаний).",
  "records.custom_preview": "🛠 Кастом превью",
  "records.col_date": "Дата",
  "records.col_turbine": "Турбина",

  "custom_preview.title": "🛠 Кастом превью",
  "custom_preview.period": "Период",
  "custom_preview.turbine": "Турбина",
  "custom_preview.type": "Тип записи",
  "custom_preview.fields": "Выбрано показателей: {n} из {total}",
  "custom_preview.select_all": "Выбрать все",
  "custom_preview.clear": "Очистить",
  "custom_preview.build_btn": "Сформировать таблицу",
  "custom_preview.building": "Формируем…",
  "custom_preview.rows_count": "Всего строк: {n}",
  "custom_preview.sort_hint": "Нажмите для сортировки",
  "records.col_slot": "Слот",
  "records.col_who": "Кто",
  "records.col_type": "Тип",
  "records.col_status": "Статус",
  "records.detail.title": "Запись #{id}",
  "records.detail.slot": "Слот",
  "records.detail.responsible": "Ответственный",
  "records.detail.started": "Начато",
  "records.detail.completed": "Завершено",
  "records.detail.response": "Отклик",
  "records.detail.fill": "Заполнение",
  "records.detail.reason": "Причина",
  "records.detail.seconds": "с",

  // ---------- My records (responsible) ----------
  "my_records.title": "📋 Мои записи",
  "my_records.download_xlsx": "📥 Скачать Excel",

  // ---------- Shifts (admin) ----------
  "shifts.title": "📅 Расписание смен",
  "shifts.choose_user": "Выбрать ответственного",
  "shifts.fill_range": "📐 Заполнить диапазон",
  "shifts.active_count": "Активные смены ({n})",
  "shifts.empty": "Смен нет. Тыкни день в календаре.",
  "shifts.range.title": "📐 Заполнить диапазон",
  "shifts.range.from": "Начало",
  "shifts.range.to": "Конец",
  "shifts.range.invalid": "Конечная дата раньше начальной",
  "shifts.range.added": "Добавлено: {added}, пропущено: {skipped}",
  "shifts.deactivated": "деактивирован",
  "shifts.more_hidden": "…и ещё {n} смен (скрыто)",

  // ---------- People & stations ----------
  "people.title": "👥 Люди и станции",
  "people.stations": "🏭 Станции ({n})",
  "people.add_station": "➕ Добавить станцию",
  "people.station.name": "Название",
  "people.station.city": "Город",
  "people.station.tz": "Timezone (Europe/Kyiv)",
  "people.station.new_title": "Новая станция",
  "people.station.name_placeholder": "Название (например, Энерго-2)",
  "people.station.confirm_delete": "Удалить станцию «{name}»?",
  "people.station.fill_required": "Заполните название и город",
  "people.invite.title": "Новое приглашение",
  "people.invite.placeholder": "ФИО ответственного",
  "people.invite.create": "➕ Создать приглашение",
  "people.invite.created_for": "✅ Приглашение для «{name}»",
  "people.invite.copy_failed": "Не удалось скопировать. Выделите ссылку вручную.",
  "people.list_title": "Ответственные ({n})",
  "people.list_empty": "Пока никого. Создайте приглашение.",
  "people.deactivate": "Деактивировать",
  "people.activate": "Активировать",
  "people.station_label": "Станция:",
  "people.station_none": "— без станции —",

  // ---------- Settings ----------
  "settings.title": "⚙ Настройки",
  "settings.notification_interval": "Интервал уведомлений, мин ({min}–{max})",
  "settings.notification_hint": "Каждые {n} минут операторам будет приходить уведомление в Telegram. Применяется со следующего тика.",
  "settings.range_error": "Допустимое значение: {min}–{max}",
  "settings.language": "Язык",
  "settings.trigger_running": "Запускаю…",
  "settings.trigger_label": "⚡ Триггер: вызвать часовой тик",
  "settings.trigger_success": "✅ Тик запущен. Ответственным на смене сейчас уйдут уведомления.",
  "settings.trigger_failed": "⚠ {error}",

  // ---------- Report (responsible landing) ----------
  "report.title": "📝 Отчёт",
  "report.ready_to_fill": "Готово к заполнению. Нажмите кнопку ниже.",
  "report.no_slot": "⏳ Сейчас нельзя внести показания",
  "report.no_slot_hint": "Турбина остановлена или вы на выходном.",
  "report.day_off": "🌴 Сегодня у вас выходной",
  "report.day_off_hint": "Уведомления приостановлены до конца смены.",
  "report.fill_btn": "Заполнить отчёт",
  "report.fill_btn_offline": "Заполнить (турбина стоит)",
  "report.fill_sub_active": "Плановые показания за текущий час",
  "report.fill_sub_disabled": "Недоступно сейчас",
  "report.fill_sub_day_off": "Недоступно — выходной",
  "report.fill_sub_offline": "Запись будет помечена оранжевым",
  "report.emergency_btn": "Экстренная ситуация",
  "report.emergency_sub": "Внеплановая запись: KW + KV",
  "report.day_off_btn_off": "Выходной",
  "report.day_off_btn_on": "Отменить выходной",
  "report.day_off_sub_off": "Отметить, что сегодня вы не работаете",
  "report.day_off_sub_on": "Возобновить уведомления по смене",
  "report.day_off_confirm_on": "Отметить сегодня как выходной? Уведомления по этой смене больше не придут.",
  "report.day_off_confirm_off": "Снять отметку «Выходной» — уведомления продолжат приходить?",

  // ---------- Report form ----------
  "report_form.title": "📋 Плановый отчёт",
  "report_form.slot_label": "Слот",
  "report_form.placeholder_pair": "X или X/Y",
  "report_form.placeholder_single": "—",
  "report_form.filled_count": "Заполнено {n} из {total}. Можно отправить и частично.",
  "report_form.expand_all": "Развернуть всё",
  "report_form.collapse_all": "Свернуть всё",
  "bool.on": "Вкл",
  "bool.off": "Выкл",
  "report_form.submit": "Отправить",
  "report_form.submit_sub": "Сохранить введённые значения",
  "report_form.submitting": "Отправляем…",
  "report_form.cancel": "Отменить",
  "report_form.cancel_sub": "Данные не сохранятся",
  "report_form.already_completed": "Этот слот уже заполнен.",
  "report_form.no_slot": "Нет открытого слота.",
  "report_form.offline_title": "Турбина остановлена",
  "report_form.offline_hint": "Запись будет сохранена, но помечена оранжевым — будет видно, что показания введены при остановленной турбине.",

  // ---------- Emergency form ----------
  "emergency.title": "🚨 Экстренная ситуация",
  "emergency.intro": "Внеплановая запись. Обязательны KW и причина; остальные показатели — по желанию. После отправки администраторы получат уведомление.",
  "emergency.reason_label": "Причина",
  "emergency.reason_placeholder": "Опишите, что произошло",
  "emergency.reason_required": "Обязательное поле",
  "emergency.submit_sub_ok": "Сохранить и уведомить администраторов",
  "emergency.submit_sub_disabled": "Сначала укажите причину",
  "emergency.show_extras": "Заполнить остальные показатели (опционально)",
  "emergency.hide_extras": "Скрыть остальные показатели",
  "emergency.landing_what": "Что такое «Экстренная ситуация»?",
  "emergency.landing_when": "Эта запись используется ТОЛЬКО при настоящих аварийных и нештатных событиях — поломка, скачок, утечка и т.п.",
  "emergency.landing_warn": "Если просто нужно внести плановые показания — закройте эту вкладку и используйте «📝 Отчёт».",
  "emergency.landing_btn": "Создать экстренную запись",
};
